import { render, staticRenderFns } from "./ModalFormularioPlanPagoConceptoUniversidad.vue?vue&type=template&id=6695a8e6"
import script from "./ModalFormularioPlanPagoConceptoUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormularioPlanPagoConceptoUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports